import { getPercentage } from './tableUtils';

const constructTableWithoutBreakDown = ({
  data = [],
  headers = [],
  groupby = [],
  groupbyKey = 'dt',
  parent = null,
}) => {
  const currdata = data?.reduce((acc, curr) => {
    const obj = {};
    curr.forEach((element, index) => {
      obj[headers[index]] = element;
    });
    obj['group_by'] = groupby[+obj[groupbyKey]];
    if (parent) {
      obj['parent'] = parent;
    }
    return [...acc, obj];
  }, []);
  return currdata;
};

const constructTableWithBreakDown = ({
  data = [],
  headers = [],
  groupby = [],
  groupbyKey = 'dt',
  breakDown = [],
  breakDownKey = 'g2',
}) => {
  const currdata = data?.reduce((acc, curr) => {
    const obj = {};
    curr.forEach((element, index) => {
      obj[headers[index]] = element;
    });
    obj['group_by'] = groupby[+obj[groupbyKey]];
    obj['subRows'] = constructTableWithoutBreakDown({
      data: curr[0],
      headers: headers,
      groupby: breakDown,
      groupbyKey: breakDownKey,
      parent: groupby[+obj[groupbyKey]],
    });
    return [...acc, obj];
  }, []);
  return currdata;
};

const addPercentagesToData = ({ data = [] }) => {
  if (!data?.length) return [];

  // Calculate totals for all numeric columns (excluding group_by, parent, subRows)
  const totals = {};
  const firstRow = data[0];

  Object.keys(firstRow).forEach((key) => {
    if (
      key !== 'group_by' &&
      key !== 'parent' &&
      key !== 'subRows' &&
      typeof firstRow[key] === 'number'
    ) {
      totals[key] = data.reduce((acc, curr) => acc + (curr[key] || 0), 0);
    }
  });

  function addPercentagesToRows(rows) {
    if (!rows?.length) return [];

    return rows.map((row) => {
      const percentageData = {};

      // Add totals and percentages for each numeric column
      Object.keys(totals).forEach((key) => {
        percentageData[`${key}_total`] = totals[key];
        percentageData[`${key}_per`] = getPercentage(row[key], totals[key]);
      });

      return {
        ...row,
        ...percentageData,
        subRows: addPercentagesToRows(row?.subRows),
      };
    });
  }

  return addPercentagesToRows(data);
};

export const flowUserActivityTableTransformer = ({ response }) => {
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {};

  const hasBreakDown = g2?.length;

  let res = [];

  if (!hasBreakDown) {
    const chartData = chart?.filter((d) => d[0] === '0');
    const data = table.length ? table : chartData;
    const groupby = table.length ? g1 : dt;
    const groupbyKey = table.length ? 'g1' : 'dt';

    // Construct table without breakdown
    res = constructTableWithoutBreakDown({
      data,
      headers,
      groupby,
      groupbyKey,
    });
  } else {
    const groupby = g1 || dt;
    const groupbyKey = g1 ? 'g1' : 'dt';

    // Construct table with breakdown
    res = constructTableWithBreakDown({
      data: table,
      headers,
      groupby,
      groupbyKey,
      breakDown: g2,
      breakDownKey: 'g2',
    });
  }

  // Add percentage calculations to the result
  res = addPercentagesToData({ data: res });

  return res;
};
